import { User } from 'lucide-react';

interface LinkMetadataDisplayProps {
  author?: string | null;
  license?: string | null;
  description?: string | null;
  tags?: string[] | null;
  linkId: string; // For tracking expanded state
  expandedDescriptions?: Set<string>;
  onToggleDescription?: (linkId: string) => void;
}

export function LinkMetadataDisplay({
  author,
  license,
  description,
  tags,
  linkId,
  expandedDescriptions = new Set(),
  onToggleDescription,
}: LinkMetadataDisplayProps) {
  const isExpanded = expandedDescriptions.has(linkId);

  return (
    <>
      {/* Author and License */}
      {(author || license) && (
        <div className="mt-2 flex flex-wrap gap-3 text-xs text-foreground-muted">
          {author && (
            <span className="flex items-center gap-1">
              <User className="h-3 w-3" />
              {author}
            </span>
          )}
          {license && <span>License: {license}</span>}
        </div>
      )}

      {/* Description */}
      {description && (
        <div className="mt-2">
          <p
            className={`text-sm text-foreground-muted whitespace-pre-wrap ${
              !isExpanded ? 'line-clamp-2' : ''
            }`}
          >
            {description}
          </p>
          {description.length > 150 && onToggleDescription && (
            <button
              onClick={() => onToggleDescription(linkId)}
              className="mt-1 text-xs text-primary hover:underline"
            >
              {isExpanded ? 'Show less' : 'Show more'}
            </button>
          )}
        </div>
      )}

      {/* Tags */}
      {tags && tags.length > 0 && (
        <div className="mt-2 flex flex-wrap gap-1">
          {tags.slice(0, 5).map((tag, idx) => (
            <span
              key={idx}
              className="px-2 py-0.5 text-xs bg-background-subtle text-foreground-muted rounded border border-border"
            >
              {tag}
            </span>
          ))}
          {tags.length > 5 && (
            <span className="px-2 py-0.5 text-xs text-foreground-muted">
              +{tags.length - 5} more
            </span>
          )}
        </div>
      )}
    </>
  );
}
